import { AlertTriangle, CircleX, Info, CircleCheck } from "lucide-react";
import * as React from "react";
import { cn } from "../lib/cn";

export type CalloutTone = "info" | "warning" | "danger" | "success" | "neutral";

const tones: Record<CalloutTone, { box: string; icon: React.ComponentType<{ className?: string }> }> = {
  info: { box: "border-info-border bg-info-bg text-info-fg", icon: Info },
  warning: { box: "border-warning-border bg-warning-bg text-warning-fg", icon: AlertTriangle },
  danger: { box: "border-danger-border bg-danger-bg text-danger-fg", icon: CircleX },
  success: { box: "border-success-border bg-success-bg text-success-fg", icon: CircleCheck },
  neutral: { box: "border-line bg-subtle text-fg-secondary", icon: Info },
};

/** Callouts and banners with one action at most (ui-spec §8.1 Alert). */
export function Callout({
  tone = "info",
  title,
  children,
  action,
  className,
  role,
}: {
  tone?: CalloutTone;
  title?: React.ReactNode;
  children?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  role?: "alert" | "status";
}) {
  const { box, icon: Icon } = tones[tone];
  return (
    <div role={role} className={cn("flex items-start gap-2.5 rounded-md border px-3 py-2.5", box, className)}>
      <Icon className="mt-0.5 size-4 shrink-0" aria-hidden />
      <div className="min-w-0 flex-1 text-ui">
        {title ? <div className="font-medium">{title}</div> : null}
        {children ? <div className="text-fg-secondary">{children}</div> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
